import { all, takeLatest, takeLeading } from 'redux-saga/effects'

import { GlobalActions } from './GlobalActions'
import {
  appEntry,
  clipboardCopy,
  jumpTo,
  notifyReady,
  updateCanvas,
} from './sagas'

export function* globalSaga() {
  yield all([
    takeLeading(GlobalActions.appEntry, appEntry),
    takeLatest(GlobalActions.jumpTo, jumpTo),
    takeLatest(GlobalActions.notifyReady, notifyReady),
    takeLatest(GlobalActions.copy, clipboardCopy),
    takeLatest(GlobalActions.updateCanvas, updateCanvas),
  ])
}
